import ReactCountryFlag from "react-country-flag";
import { useHistory } from "react-router-dom";
import { ChevronDown, Search } from "react-feather";
import Select from "react-select";
import { useEffect, useRef, useState } from "react";
import CategoryContainer from "./categoryContainer";
import { useDebounce } from "@utils/utils";
import AutoSuggestDropdown from "./autoSuggest";
import { useDispatch, useSelector } from "react-redux";
import { PillColor, SEARCH_TYPE_MAPPING, match_type_options, profileTypeHandler, searchTypeCustomStyles } from "./const";
import { addToFavourite, getAllCategoryAutoSuggest, getChemicalKeywordAutoSuggest, getCompanyNameAutoSuggest, getHsCodeAutoSuggest, getHsCodeDetails, getLogisticsPortsAutoSuggest, getProductKeywordAutoSuggest, getProfileDetails, getProfileDetailsSummary, removeSearchTab, useRecentAutoSuggestSuggestions } from "./services";
import { redirectingProfileEnum, redirectionInCountryDictionary, redirectionTypePayload, searchPhraseDictionary } from "@core/global/global-country-dictionary";
import ReactTooltip from "react-tooltip";
import { Form } from "react-bootstrap";
import Button from "@components/base/button";
import StarKidFill from "@assets/images/icons/kidStarFill.svg";
import { CLOUDINARY_INTEL_URL } from "@utils/enum";
import { TRADE_DIRECTIONS } from "@containers/shipments/utils";
import { getCountryUsingUrl } from "@containers/shipments/utils/helper";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import { searchParametersHandler } from "@redux/Shipment/shipmentSlice";
import AllCategoryAutoSuggest from "./allCategoryAutoSuggest";
import { toast } from "react-toastify";
import { redirectionUrls } from "@routes/intel/dashboard/const";
import InfoIcon from "../../../assets/images/InfoIcon.svg";
import UpgradeGreenIcon from "../../../assets/images/Solid_Status_Lightning-Green.svg";
import { getPaymentsUrl } from "@utils/paymentsUrl";
import LocalStorageService from "@core/services/local-storage.service";
import { trademoTrackingEvents } from "@core/global/trademo-tracking";
import { generateTrackingObject } from "@core/global/global-country-functions";
import DataSource from "./dataSource";
import AddFavModal from "../../AddFavModal";
import CompanyProfileEmailAlertModal from "../../../routes/intel/us/company-profile/company-profile-email-alert-modal";
import { globalCountryDetailsDictionary } from "@core/global/global-country-details";
import { CountryCodeOneToOneMap } from "@core/dictionary/global";
const defaultSearchKey = { value: "entire_bill_of_lading", label: "All Categories", placeHolder: "Type to search in all categories…" };
const countryFlag = {
  ch: "cl",
  pr: "pe",
};
const PrimarySearchCard = (props) => {
  const { searchKey, searchCardOptions, isShipmentLoader, searchButtonLoaderHandler, newIntelLoader, searchBottonCalled, defaultData, searchBottonCalledForChemical, setSearchCardHandler, closeLoader, redirectDirection, redirectCountry, showGetInTouch, handleGetInTouchClose, handleGetInTouchOpen, setClickPostSearchSugg, gettingPostSearchResults } = props;
  const { suggestions, getRecentAutoSuggestSuggestions } = useRecentAutoSuggestSuggestions();
  const [dropdownOptions] = useState(searchCardOptions || []);
  const [searchKeyLabel, setSearchKeyLabel] = useState(dropdownOptions?.[0] ?? []);
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentProfileName, setCurrentProfileName] = useState("");
  const [dataSourceAccess, setDataSourceAccess] = useState([]);
  const [isFavourite, setIsFavourite] = useState(false);
  const [isEmailAlert, setIsEmailAlert] = useState(false);
  const [showFavModal, setShowFavModal] = useState(false);
  const [showEmailAlert, setShowEmailAlert] = useState(false);
  const [showAutoSuggest, setShowAutoSuggest] = useState(false);
  const [prospectData, setProspectData] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [matchType, setMatchType] = useState(match_type_options[0]);
  const [selectedData, setSelectedData] = useState([]);
  const [showAddDropdown, setShowAddDropdown] = useState(false);
  const [isSelectedFromAutoSuggest, setIsSelectedFromAutoSuggest] = useState(false);
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const [redirectionId, setRedirectionId] = useState({});
  const [visibleSuggestions, setVisibleSuggestions] = useState([]);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [isRecentSearchClicked, setIsRecentSearchClicked] = useState(false);
  const [isMatchTypeExact, setIsMatchTypeExact] = useState(false);
  const debouncedInputValue = useDebounce(inputValue, 300);
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);
  const dataSourceRef = useRef(null);
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const dataSourceList = useSelector((state) => state?.userDetails?.creditDetails?.dataSourceList);
  const GLOBALPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("global"))?.navigate === "search";
  const STARTERPLAN = creditDetails?.data?.find((data) => data?.is_active && data?.user_active_plan?.toLowerCase()?.includes("starter"))?.navigate === "search";
  const redirectFrom = new URLSearchParams(window.location.search).get("redirectingProfile") ? redirectingProfileEnum[new URLSearchParams(window.location.search).get("redirectingProfile")]?.payloadType : null;
  const redirectingProfileId = new URLSearchParams(window.location.search)?.get("redirectingProfileIds") ?? null;
  const redirectProfileType = new URLSearchParams(window.location.search).get("redirectingProfile") ? redirectionTypePayload[new URLSearchParams(window.location.search).get("redirectingProfile")] : null;
  const mergeID = new URLSearchParams(window.location.search).get("mergedID");
  const profileId = new URLSearchParams(window.location.search).get("profileId");
  const profileName = new URLSearchParams(window.location.search).get("profileName");
  const companyName = new URLSearchParams(window.location.search).get("companyName");
  const parentCompany = new URLSearchParams(window.location.search).get("isSubsidiaryIncluded");
  const isSubs = new URLSearchParams(window.location.search).get("isSubsidiaryIncluded") === "true";
  const tab = new URLSearchParams(window.location.search).get("tab");
  const itemNumberId = new URLSearchParams(window.location.search).get("itemNumberId");
  const countryType = new URLSearchParams(window.location.search).get("countryType");
  const redirectionHsCodeValue = new URLSearchParams(window.location.search).get("hsCode");
  const searchCardDetails = useSelector((state) => state?.shipmentDetails?.searchParameters);
  const currentPlanAccess = useSelector((state) => state?.shipmentDetails?.planDetails);
  const searchUrlParams = window.location.search;
  const localStorageService = LocalStorageService.getService();
  const dispatch = useDispatch();
  const history = useHistory();
  const datasourceUpsell = document.getElementById("datasource-upsell");
  const tabEventExceptions = ["All Categories", "Product Category", "HS Code", "Chemicals"];
  const searchDisable = STARTERPLAN && currentPlanAccess?.search_starter_current_count >= currentPlanAccess?.search_starter_max_count;

  const handleClearAll = () => {
    setSelectedData([]);
    setRedirectionId({});
    setIsSelectedFromAutoSuggest(false);
    setIsOpen(true);
    setShowAddDropdown(true);
    setShowAutoSuggest(true);
    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 0);
    dispatch(
      searchParametersHandler({
        searchCategory: searchKeyLabel.value,
        searchedItem: "",
        dataSource: `multi_country`,
        matchType: match_type_options[0].value,
      })
    );
    setClickPostSearchSugg(false);
  };

  function handleClickOutside(event) {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsOpen(false);
      setShowAddDropdown(false);
      setShowAutoSuggest(false);
    }
    if (dataSourceRef.current && !dataSourceRef.current.contains(event.target) && !datasourceUpsell) {
      setShowDropdown(false);
    }
  }
  useEffect(() => {
    if (debouncedInputValue || searchKeyLabel?.value === searchPhraseDictionary.product_category) fetchSuggestions();
  }, [debouncedInputValue]);

  useEffect(() => {
    if (searchKeyLabel.value === searchPhraseDictionary.product_category && (filteredSuggestions.length === 0 || selectedData.length === 0)) {
      setIsOpen(false);
      setShowAutoSuggest(true);
      setShowSuggestions(true);
      inputRef?.current?.focus();
      if (selectedData.length > 0) {
        setShowAutoSuggest(false);
      }
    }
  }, [searchKeyLabel, selectedData]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef, dataSourceRef, datasourceUpsell]);

  useEffect(() => {
    if (props?.isReloadSearchClicked || gettingPostSearchResults) {
      const currentKey = searchCardOptions?.find((item) => item.value === searchKey);
      const searchItem = props?.searchedItem !== "" ? (props?.searchedItem?.includes("||") ? props?.searchedItem.split("||").map((search) => ({ label: search, value: search, mongoId: searchCardDetails?.matchType === "exact" ? "CUSTOM_MONGO_ID" : null })) : [{ label: props?.searchedItem ?? "", value: props?.searchedItem ?? "", mongoId: searchCardDetails?.matchType === "exact" ? "CUSTOM_MONGO_ID" : null }]) : [];
      setSearchKeyLabel({ ...currentKey });
      setSelectedData(searchItem);
      dispatch(
        searchParametersHandler({
          searchCategory: searchKey,
          searchedItem: props?.searchedItem ?? "",
          dataSource: searchCardDetails?.dataSource,
          matchType: searchCardDetails?.matchType,
          redirectionId: searchCardDetails?.redirectionId ?? {},
        })
      );
    }
    setIsMatchTypeExact(searchCardDetails?.matchType === "exact");
  }, [props?.isReloadSearchClicked, gettingPostSearchResults]);

  useEffect(() => {
    if (redirectFrom) {
      getProfileDetailsHandler();
      getProfileHandler();
    }
    if (new URLSearchParams(searchUrlParams).get("redirectingFrom") === redirectionInCountryDictionary.hsCodeProfile) {
      getHsCodeDetailsHandler();
    }
    if (!props?.isReloadSearchClicked) {
      const countryCode = searchCardDetails?.dataSource?.split("_")?.[0]?.toLowerCase();
      if (countryCode?.includes("multi_country")) {
        dispatch(searchParametersHandler({ ...searchCardDetails, dataSource: `${"multi_country"}` }));
      } else if (defaultData) {
        dispatch(searchParametersHandler({ ...searchCardDetails, dataSource: `${["ch", "pr"].includes(defaultData?.countryCode?.toLowerCase()) ? countryFlag[defaultData?.countryCode?.toLowerCase()] : defaultData?.countryCode?.toLowerCase()}_${defaultData?.countryType}` }));
      }
    }
    if (itemNumberId) {
      setDataSourceAccess([
        {
          count: 578107,
          country_code: globalCountryDetailsDictionary[countryType]?.countryCode,
          country_name: globalCountryDetailsDictionary[countryType]?.countryShortHand || globalCountryDetailsDictionary[countryType]?.country_CamelCase,
          isSubscribed: true,
          source: globalCountryDetailsDictionary[countryType]?.countryType,
        },
      ]);
    }
  }, [searchKey, redirectFrom, itemNumberId]);

  useEffect(() => {
    if (searchCardDetails && !props?.type) {
      if (searchCardDetails?.searchCategory) setSearchKeyLabel({ value: searchCardDetails?.searchCategory, label: SEARCH_TYPE_MAPPING[searchCardDetails?.searchCategory] });
      if (searchCardDetails?.searchedItem && searchCardDetails?.searchCategory !== "entire_bill_of_lading") {
        if (isRecentSearchClicked) {
          setSelectedData(searchCardDetails?.searchedItem?.split("||").map((search) => ({ label: search, value: search, mongo_id: searchCardDetails?.matchType === "exact" ? "CUSTOM_MONGO_ID" : null })));
          setIsRecentSearchClicked(false);
        } else {
          setSelectedData(searchCardDetails?.searchedItem?.split("||").map((search) => ({ label: search, value: search, mongo_id: redirectionId?.[search] || null })));
        }

        if (searchCardDetails?.matchType) {
          if (searchCardDetails?.searchCategory === "importers" || searchCardDetails?.searchCategory === "exporters" || searchCardDetails?.searchCategory === "logistics" || searchCardDetails?.searchCategory === "ports") {
            setMatchType(match_type_options?.find((option) => option.value === searchCardDetails?.matchType));
          }
        }
      } else if (searchCardDetails?.searchedItem) {
        setInputValue(searchCardDetails?.searchedItem);
        setSelectedData([]);
        if (searchCardDetails?.matchType) {
          if (searchCardDetails?.searchCategory === "importers" || searchCardDetails?.searchCategory === "exporters" || searchCardDetails?.searchCategory === "logistics" || searchCardDetails?.searchCategory === "ports") {
            if (isMatchTypeExact || searchCardDetails?.matchType === "exact") {
              setMatchType({ value: "exact", label: "Exact Phrase" });
            } else {
              setMatchType({ value: "contains", label: "Contains" });
            }
          } else {
            setMatchType(match_type_options?.find((option) => option.value === searchCardDetails?.matchType));
          }
        }
      } else {
        setInputValue("");
        setSelectedData([]);
        setSearchKeyLabel(defaultSearchKey);
      }
    }
  }, [searchCardDetails]);

  const fetchSuggestions = async (data) => {
    try {
      setIsLoaderActive(true);
      let options = [];
      if (searchKeyLabel?.value === searchPhraseDictionary.importers) {
        options = await getCompanyNameAutoSuggestOptions(debouncedInputValue.toLowerCase(), "I");
      } else if (searchKeyLabel?.value === searchPhraseDictionary.exporters) {
        options = await getCompanyNameAutoSuggestOptions(debouncedInputValue.toLowerCase(), "E");
      } else if (searchKeyLabel?.value === searchPhraseDictionary.product_description) {
        options = await getProductKeywordAutoSuggestOptions(debouncedInputValue.toLowerCase());
      } else if (searchKeyLabel?.value === searchPhraseDictionary.product_hscode) {
        options = await getHsCodeAutoSuggestOptions(debouncedInputValue.toLowerCase());
      } else if (searchKeyLabel?.value === searchPhraseDictionary.logistics) {
        options = await getLogisticsPortsAutoSuggestOptions(debouncedInputValue.toLowerCase(), "logistic");
      } else if (searchKeyLabel?.value === searchPhraseDictionary.ports) {
        options = await getLogisticsPortsAutoSuggestOptions(debouncedInputValue.toLowerCase(), "port");
      } else if (searchKeyLabel?.value === searchPhraseDictionary.chemical_description) {
        options = await getChemicalKeywordAutoSuggestOptions(debouncedInputValue.toLowerCase());
      } else if (searchKeyLabel?.value === searchPhraseDictionary.product_category) {
        options = await getLogisticsPortsAutoSuggestOptions(debouncedInputValue.toLowerCase(), "product_category", data);
      } else {
        options = await getAllCategoryAutoSuggestOptions(debouncedInputValue.toLowerCase());
      }
      if (options?.loading) {
        setIsLoaderActive(true);
      } else {
        let updatedFilter = options;
        if (selectedData.length) {
          const currentSelected = selectedData.map((item) => item.label);
          updatedFilter = options.filter((item) => !currentSelected.includes(item.label));
        }
        setFilteredSuggestions(updatedFilter || []);
        setIsLoaderActive(false);
      }
      if (inputRef?.current?.value === "" && searchKeyLabel?.value !== searchPhraseDictionary.product_category) {
        setFilteredSuggestions([]);
      }
    } catch (error) {
      setIsLoaderActive(false);
    }
  };

  const upgradeNow = () => {
    window.location.href = getPaymentsUrl() + "payment?T=" + localStorageService.getAccessToken() + "&I=" + localStorageService.getSessionID() + "&D=" + localStorageService.getSessionExpiryDate() + "&type=plans&P=" + localStorageService.getUserProduct();
  };

  const getProductKeywordAutoSuggestOptions = async (query) => {
    const options = await getProductKeywordAutoSuggest(query, selectedData);
    return options;
  };
  const getChemicalKeywordAutoSuggestOptions = async (query) => {
    const options = await getChemicalKeywordAutoSuggest(query, selectedData);
    return options;
  };
  const getAllCategoryAutoSuggestOptions = async (query) => {
    const options = await getAllCategoryAutoSuggest(query, defaultData?.country_small, defaultData?.countryCode, props?.countryType);
    return options;
  };
  const getCompanyNameAutoSuggestOptions = async (query, companyType) => {
    const options = await getCompanyNameAutoSuggest(query, defaultData?.countryCode, props?.countryType, companyType, selectedData);
    return options;
  };

  const getHsCodeAutoSuggestOptions = async (query) => {
    const options = await getHsCodeAutoSuggest(query, defaultData?.country_small, selectedData);
    return options;
  };

  const getLogisticsPortsAutoSuggestOptions = async (query, type, data) => {
    if (data) {
      const options = await getLogisticsPortsAutoSuggest(query, defaultData?.countryCode, props?.countryType, type, data);
      return options;
    } else {
      const options = await getLogisticsPortsAutoSuggest(query, defaultData?.countryCode, props?.countryType, type, selectedData);
      return options;
    }
  };

  const getProfileDetailsHandler = async () => {
    const { companyProfileName, dataSourceAccess, profileSummaryDetails } = (await getProfileDetailsSummary(redirectProfileType, redirectFrom, redirectingProfileId, profileId, mergeID, companyName, profileName)) || {};
    setCurrentProfileName(companyProfileName);
    setDataSourceAccess(dataSourceAccess);
    setSummaryData(profileSummaryDetails);
  };

  const getHsCodeDetailsHandler = async () => {
    const { dataSourceAccess, profileName } = (await getHsCodeDetails()) || {};
    setCurrentProfileName(profileName || "");
    setDataSourceAccess(dataSourceAccess || []);
  };

  const getProfileHandler = async () => {
    const { isFavourite, isEmailAlert } = (await getProfileDetails(redirectProfileType, redirectFrom, redirectingProfileId, profileId, mergeID, companyName, profileName)) || {};
    setIsFavourite(isFavourite);
    setIsEmailAlert(isEmailAlert);
  };

  const handleInputChange = (e) => {
    // if (searchDisable) {
    //   return;
    // }
    setInputValue(e.target.value);
    setShowSuggestions(true);
    setIsLoaderActive(true);
    setShowAutoSuggest(true);
    setIsOpen(false);
    setIsSelectedFromAutoSuggest(false);
    if (e.target.value === "") {
      if (searchKeyLabel.value === searchPhraseDictionary.product_category) {
        setShowAutoSuggest(true);
        setIsOpen(false);
      } else {
        setIsOpen(true);
        setShowAutoSuggest(false);
        setFilteredSuggestions([]);
      }
    }
  };

  const navigateLink = (value) => {
    let url = window.location.href;
    let search = window.location.search;
    let subsCheck = new URLSearchParams(search).get("isSubsidiaryIncluded");
    if (subsCheck === "true") {
      url = url.replace("isSubsidiaryIncluded=true", `isSubsidiaryIncluded=${false}`);
    } else if (subsCheck === "false") {
      url = url.replace("isSubsidiaryIncluded=false", `isSubsidiaryIncluded=${true}`);
    } else {
      url = url + `&isSubsidiaryIncluded=${value}`;
    }
    window.location.href = url;
  };

  const addToProspect = () => {
    if (props.callingPendoEvent) {
      props.callingPendoEvent(trackingEventDictionary.companyProfilePageAddToFavouritesButton);
    }
    const requestObject = [
      {
        company_name: summaryData?.name || summaryData?.trade_lane_name,
        company_id: summaryData.elastic_data_id[0],
        company_country: summaryData.country,
        trade_direction: tab ? TRADE_DIRECTIONS[tab] : summaryData?.is_buyer ? "import" : "export",
        data_source: getCountryUsingUrl(),
      },
    ];
    setProspectData(requestObject);
    setShowFavModal(true);
  };

  const addToFavouriteHandler = () => {
    const setAlert = addToFavourite(summaryData, tab);
    setShowEmailAlert(false);
    setIsEmailAlert(setAlert);
    if (props.callingPendoEvent) {
      props.callingPendoEvent(trackingEventDictionary.companyProfileSetEmailAlertConfirm);
    }
  };
  const handleEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if ((new URLSearchParams(searchUrlParams).get("country") && new URLSearchParams(searchUrlParams).get("type")) || props?.type) {
      let searchValue = "";
      if (selectedData && selectedData?.length !== 0 && searchKeyLabel?.value === searchPhraseDictionary.product_hscode) {
        selectedData.map((item) => {
          if (item.label.includes(":")) {
            searchValue = searchValue + item.label.split("-")[0].split(":")[1].slice(0, -1) + "||";
          } else {
            searchValue = searchValue + item.label + "||";
          }
        });
        searchValue = searchValue.slice(0, -2);
      } else if (selectedData && selectedData?.length !== 0 && searchKeyLabel?.value === searchPhraseDictionary.chemical_description) {
        selectedData.map((item) => (searchValue = searchValue + `${item.label}|${item.value}`));
      } else {
        searchValue = inputValue && inputValue !== "" ? inputValue : selectedData?.map((data) => data.label).join("||");
      }
      const countryCode = searchCardDetails?.dataSource?.split("_")[0];
      if (GLOBALPLAN) {
        dispatch(searchParametersHandler({ searchCategory: searchKeyLabel?.value, searchedItem: searchValue, matchType: matchType.value, dataSource: `${"global_plan"}`, comingFrom: "companyProfile", redirectionId: redirectionId }));
        history.push("/global-search");
      } else if (countryCode?.includes("multi") || countryCode?.includes("world")) {
        dispatch(searchParametersHandler({ searchCategory: searchKeyLabel?.value, searchedItem: searchValue, matchType: matchType.value, dataSource: `${"multi_country"}`, comingFrom: "companyProfile", redirectionId: redirectionId }));
        history.push("/all-country-shipments");
      } else {
        dispatch(searchParametersHandler({ searchCategory: searchKeyLabel?.value, searchedItem: searchValue, matchType: matchType.value, dataSource: `${countryCode || defaultData?.countryCode}_${redirectDirection || defaultData?.countryType}`, comingFrom: "companyProfile", redirectionId: redirectionId }));
        history.push("/" + redirectionUrls[countryCode?.toLowerCase() + "_" + redirectDirection?.toLowerCase() + "s"]);
      }
    } else {
      if (searchButtonLoaderHandler) searchButtonLoaderHandler();
      if (isShipmentLoader || newIntelLoader) return;
      searchBottonClicked(e);
    }
  };

  const searchPayloadHandler = () => {
    let searchedArr = selectedData?.map((data) => data.label) || [];
    if (inputValue && inputValue !== "") {
      searchedArr.push(inputValue.trim());
    }
    return searchedArr.join("||");
  };

  const searchBottonClicked = (event, val, item, chemical) => {
    if (searchButtonLoaderHandler) searchButtonLoaderHandler();

    if (isShipmentLoader || newIntelLoader) return;

    if (!isShipmentLoader) {
      if (searchKeyLabel?.value === searchPhraseDictionary.product_hscode && selectedData?.length === 0 && !val) {
        toast.error("Please select HS Code from auto suggest");
        closeLoader();
        return;
      }
      if (searchKeyLabel?.value === searchPhraseDictionary.product_category && selectedData?.length === 0 && !val) {
        toast.error("Please select Product Category from auto suggest");
        closeLoader();
        return;
      }
      let searchInclude = false;
      if ((!!inputValue && inputValue !== "" && searchKeyLabel?.value === searchPhraseDictionary.product_description) || searchKeyLabel?.value === searchPhraseDictionary.allCategory) {
        searchInclude = true;
      }
      if (val) {
        if (item?.is_chemical) {
          searchBottonCalled(item?.search?.join("||"), false, searchPhraseDictionary.chemical_description, matchType.value, false, { [item.search[0]]: item.redirection_profile_id });
          dispatch(searchParametersHandler({ searchCategory: searchPhraseDictionary.chemical_description, searchedItem: item.search.join("||"), matchType: matchType.value, dataSource: `${redirectCountry || ["ch", "pr"].includes(defaultData?.countryCode?.toLowerCase()) ? countryFlag[defaultData?.countryCode?.toLowerCase()] : defaultData?.countryCode?.toLowerCase()}_${redirectDirection || defaultData?.countryType}`, redirectionId: redirectionId || {} }));
          setSearchCardHandler({
            searchedItem: item.search.join("||"),
            searchInclude: false,
            currentKey: searchPhraseDictionary.chemical_description,
            matchType: matchType.value,
          });
        } else {
          searchBottonCalled(item?.search?.join("||"), false, item.key, matchType.value, false, { [item.search[0]]: item.redirection_profile_id });
          dispatch(searchParametersHandler({ searchCategory: item.key, searchedItem: item.search.join("||"), matchType: item.queryType, dataSource: `${redirectCountry || ["ch", "pr"].includes(defaultData?.countryCode?.toLowerCase()) ? countryFlag[defaultData?.countryCode?.toLowerCase()] : defaultData?.countryCode?.toLowerCase()}_${redirectDirection || defaultData?.countryType}`, redirectionId: redirectionId || {} }));
          setSearchCardHandler({
            searchedItem: item.search.join("||"),
            searchInclude: false,
            currentKey: item.key,
            matchType: item.queryType,
          });
          setIsRecentSearchClicked(true);
        }
      } else {
        let searchValue = "";
        if (selectedData && selectedData?.length !== 0 && searchKeyLabel?.value === searchPhraseDictionary.product_hscode) {
          selectedData?.map((item) => {
            if (item.label.includes(":")) {
              searchValue = searchValue + item.label.split("-")[0].split(":")[1].slice(0, -1) + "||";
            } else {
              searchValue = searchValue + item.label + "||";
            }
          });
          searchValue = searchValue.slice(0, -2);
        } else if (selectedData && selectedData?.length !== 0 && searchKeyLabel?.value === searchPhraseDictionary.chemical_description) {
          searchValue = selectedData.map((item) => (item.label !== item.value ? `${item.label}|${item.value}` : item.value)).join("||");
        } else {
          searchValue = searchPayloadHandler();
        }
        setSearchCardHandler({
          searchedItem: searchValue,
          searchInclude: false,
          currentKey: searchKeyLabel?.value === searchPhraseDictionary?.allCategory ? searchPhraseDictionary?.entire_bill_of_lading : searchKeyLabel.value === searchPhraseDictionary.chemical_description ? searchPhraseDictionary?.chemical_description : searchKeyLabel?.value,
          matchType: matchType.value,
        });
        dispatch(searchParametersHandler({ searchCategory: searchKeyLabel?.value, searchedItem: searchValue, matchType: searchKeyLabel?.value === searchPhraseDictionary.importers || searchKeyLabel?.value === searchPhraseDictionary.exporters || searchKeyLabel?.value === searchPhraseDictionary.ports || searchKeyLabel?.value === searchPhraseDictionary.logistics ? (isMatchTypeExact ? match_type_options[1].value : match_type_options[0].value) : matchType.value, dataSource: `${redirectCountry || ["ch", "pr"].includes(defaultData?.countryCode?.toLowerCase()) ? countryFlag[defaultData?.countryCode?.toLowerCase()] : defaultData?.countryCode?.toLowerCase()}_${redirectDirection || defaultData?.countryType}`, redirectionId: redirectionId || {} }));

        setTimeout(() => {
          searchBottonCalled(searchValue, searchInclude, searchKeyLabel?.value === searchPhraseDictionary.allCategory ? searchPhraseDictionary.entire_bill_of_lading : searchKeyLabel.value === searchPhraseDictionary.chemical_description ? searchPhraseDictionary.chemical_description : searchKeyLabel?.value, matchType.value, isSelectedFromAutoSuggest, redirectionId);
        }, 1000);
      }
      setIsOpen(false);
      setShowAddDropdown(false);
      setShowAutoSuggest(false);
      setShowDropdown(false);
      if (searchKeyLabel.value !== searchPhraseDictionary.entire_bill_of_lading) setInputValue("");
      if (searchBottonCalledForChemical && item?.isChemical) searchBottonCalledForChemical(item?.isChemical || chemical);
    }
  };
  const trackingEvents = (index) => {
    let temp;
    if (index === searchPhraseDictionary.entire_bill_of_lading) {
      temp = trackingEventDictionary.searchCategoryAllCategories;
    } else if (index === searchPhraseDictionary.product_description) {
      temp = trackingEventDictionary.searchCategoryProductChemicals;
    } else if (index === searchPhraseDictionary.product_hscode) {
      temp = trackingEventDictionary.searchCategoryHsCode;
    } else if (index === searchPhraseDictionary.exporters) {
      temp = trackingEventDictionary.searchCategoryShipper;
    } else if (index === searchPhraseDictionary.importers) {
      temp = trackingEventDictionary.searchCategoryConsignee;
    } else if (index === searchPhraseDictionary.ports) {
      temp = trackingEventDictionary.searchCategoryPorts;
    } else if (index === searchPhraseDictionary.logistics) {
      temp = trackingEventDictionary.searchCategoryLogistics;
    } else if (index === searchPhraseDictionary.product_category) {
      temp = trackingEventDictionary.searchCategoryProductCategory;
    } else if (index === searchPhraseDictionary.chemical_description) {
      temp = trackingEventDictionary.searchCategoryChemical;
    }
    if (defaultData) {
      trademoTrackingEvents(temp, generateTrackingObject(props.analyticsCountryID, window.location.pathname, currentPlanAccess?.subscribed_plan));
    }
  };

  const setSearchKeyLabelHandler = async (value) => {
    setSearchKeyLabel(value);
    setInputValue("");
    setSelectedData([]);
    setShowAddDropdown(false);
    trackingEvents(value.value);
    if (value.value === searchPhraseDictionary.product_category) {
      const options = await getLogisticsPortsAutoSuggestOptions(debouncedInputValue.toLowerCase(), "product_category");
      setFilteredSuggestions(options);
      setShowAutoSuggest(true);
      setShowSuggestions(true);
    }
  };

  const handleRedirection = (suggestion) => {
    let redirectionIdCopy = { ...redirectionId };
    if (searchKeyLabel.value === "product_hscode") {
      redirectionIdCopy[suggestion?.value?.split("-")[0]?.split(":")[1]?.trim()] = suggestion?.value?.split("-")[0]?.split(":")[1]?.trim();
    } else redirectionIdCopy[suggestion.label] = suggestion?.mongo_id;
    setRedirectionId(redirectionIdCopy);
  };

  const handleSuggestionClick = (suggestion) => {
    setSelectedData([...selectedData, suggestion]);
    setInputValue("");
    setShowSuggestions(false);
    setVisibleSuggestions([]);
    setShowLoadMore(false);
    setIsSelectedFromAutoSuggest(true);
    inputRef?.current?.focus();
  };

  const handleKeyInput = (e) => {
    // if (searchDisable) {
    //   return;
    // }
    if (e.key === "Enter") {
      handleEnter(e);
    } else if (e.key === "Tab" && inputValue.trim() && !tabEventExceptions.includes(searchKeyLabel.label)) {
      if (inputValue !== inputValue.trim()) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      const isAlreadyPresent = selectedData.find((item) => item.label === inputValue);
      if (!isAlreadyPresent || Object.keys(isAlreadyPresent).length === 0) {
        setIsSelectedFromAutoSuggest(true);
        const inputObj = visibleSuggestions.find((suggestion) => suggestion.label === inputValue);
        const { mongo_id: mongoId = null } = inputObj || {};
        handleRedirection(inputObj || []);
        handleSuggestionClick({ label: inputValue, value: inputValue, mongo_id: mongoId });
        inputRef?.current?.focus();
      }
    }
  };

  const maintainInputFocus = () => {
    setTimeout(() => {
      inputRef?.current?.focus();
    }, 0);
  };

  const handleOptionChange = (option) => {
    setMatchType(option);
    setIsMatchTypeExact(option.value === "exact");
  };

  return (
    <div className={`tw-px-0 tw-py-4 tw-mx-auto tw-w-full ${props?.isMirror ? "tw-max-w-[1060px]" : "tw-max-w-[980px]"}`} onClick={() => (searchDisable ? handleGetInTouchOpen() : null)}>
      {(searchUrlParams.includes("redirectingFrom=") || redirectionHsCodeValue) && (
        <div className="tw-flex tw-items-center tw-justify-between tw-pb-4 tw-w-full">
          <div className="tw-flex tw-items-center tw-gap-1">
            <span className="tw-py-1 tw-px-3 tw-bg-primary-purple-50 tw-text-sm tw-font-medium tw-text-primary-purple-600 tw-rounded-2xl tw-cursor-pointer" onClick={() => (window.location.href = window.location.href.replace(window.location.search, ""))}>
              All Shipments
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#1c1b1f">
              <path d="M383-480 200-664l56-56 240 240-240 240-56-56 183-184Zm264 0L464-664l56-56 240 240-240 240-56-56 183-184Z" />
            </svg>
            <span className="tw-flex tw-items-center tw-justify-start tw-text-sm tw-font-medium tw-text-gray-900 tw-tracking-tight" data-for="company-name" data-tip={currentProfileName || ""}>
              Shipments of &nbsp;
              {currentProfileName ? <span className="tw-capitalize">{currentProfileName?.length > 15 ? currentProfileName.slice(0, 15) + "..." : currentProfileName}</span> : ""}
              {currentProfileName && currentProfileName?.length > 15 && <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="bottom" id="company-name" />}
              {itemNumberId || ""}
              &nbsp; {SEARCH_TYPE_MAPPING[redirectProfileType] ? "as " + SEARCH_TYPE_MAPPING[redirectProfileType] : ""} {redirectionHsCodeValue ? "as HS Code" : ""}
            </span>
          </div>
          {parentCompany && (
            <div>
              <div>
                <div className="tw-flex tw-items-center" id="parent-switch">
                  <span className="tw-mr-1 tw-text-sm tw-font-medium tw-text-gray-900 tw-tracking-tight">Include Subsidiaries Data</span>
                  <span className={isSubs ? "twolevel-checkbox" : "twolevel-checkbox-uncheck"}>
                    <Form.Check
                      type="switch"
                      id="custom-switch-5"
                      checked={isSubs}
                      onChange={(e) => {
                        navigateLink(e.target.checked);
                      }}
                    />
                  </span>
                </div>
              </div>
            </div>
          )}
          <div className="tw-flex tw-items-center tw-gap-1">
            {!mergeID && !redirectionHsCodeValue && !searchUrlParams.includes("redirectingFrom=port") && !searchUrlParams.includes("redirectingFrom=trade_region") && !searchUrlParams.includes("redirectingFrom=logistics") ? (
              isEmailAlert ? (
                <div data-for="email-alert" data-tip="You've already set an alert for this company. To modify the alert, simply visit your Favourite Companies located in the Dashboard." className="d-flex align-items-center mx-3">
                  <img className="mr-1" src={`${CLOUDINARY_INTEL_URL}/icons/notifications_active_ofvtku.svg`} /> <span className="email-alert-allReadySet">Alert Set</span>
                  <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="bottom" id="email-alert" />
                </div>
              ) : (
                <Button
                  id="email-alert"
                  variant={"secondaryWithIcon"}
                  size={"medium"}
                  onClick={() => {
                    setShowEmailAlert(true);
                    if (props.callingPendoEvent) {
                      props.callingPendoEvent(trackingEventDictionary.companyProfileSetEmailAlert);
                    }
                  }}>
                  <span className="material-symbols-outlined">notifications</span> Set Email Alert
                </Button>
              )
            ) : (
              <></>
            )}
            {!redirectionHsCodeValue && (
              <Button variant={"secondaryWithIcon"} size={"medium"} onClick={() => addToProspect()}>
                {isFavourite ? <img className="bookmarked_icon" src={StarKidFill} width={20} height={20} /> : <span className="material-symbols-outlined">kid_star</span>}
                <span>{isFavourite ? "Bookmarked" : "Bookmark"}</span>
              </Button>
            )}
          </div>
        </div>
      )}
      <div className="tw-flex tw-gap-4 tw-items-center tw-justify-center">
        <div className={`tw-flex tw-justify-between tw-py-4 tw-px-6 tw-rounded-[42px] tw-border tw-border-gray-200 tw-bg-white tw-shadow-searchBar tw-w-full tw-relative tw-h-[85px] ${searchDisable ? "tw-opacity-50" : ""} tw-gap-4`}>
          {!GLOBALPLAN && (
            <div className="tw-flex tw-items-center" ref={dataSourceRef}>
              <div className="tw-flex tw-flex-col tw-gap-1.5">
                <span className="tw-text-xs tw-font-medium tw-text-gray-900">Data Source</span>
                <div className="tw-flex tw-items-center tw-gap-3 tw-border-none tw-text-sm" onClick={() => setShowDropdown(!showDropdown)}>
                  {defaultData ? (
                    <div className="tw-text-nowrap">
                      {dataSourceList?.[["ch", "pr"].includes(defaultData?.countryCode?.toLowerCase()) ? countryFlag[defaultData?.countryCode?.toLowerCase()] : defaultData?.countryCode?.toLowerCase()] ? (
                        defaultData?.countryCode?.toLowerCase() === "middleeast" ? (
                          <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1759845304/intel/misc/Middle_East_vtbphh.svg" className="tw-h-3.5 tw-w-3.5 mr-2" />
                        ) : CountryCodeOneToOneMap[defaultData?.countryCode?.toLowerCase()] ? (
                          <ReactCountryFlag svg countryCode={CountryCodeOneToOneMap[defaultData?.countryCode?.toLowerCase()]} className="trademo-search-flag mr-2" />
                        ) : (
                          dataSourceList?.[["ch", "pr"].includes(defaultData?.countryCode?.toLowerCase()) ? countryFlag[defaultData?.countryCode?.toLowerCase()] : defaultData?.countryCode?.toLowerCase()]?.[defaultData?.countryType]?.countryCode && <ReactCountryFlag className="trademo-search-flag mr-2" countryCode={["ch", "pr"].includes(defaultData?.countryCode?.toLowerCase()) ? countryFlag[defaultData?.countryCode?.toLowerCase()] : defaultData?.countryCode?.toLowerCase()} svg />
                        )
                      ) : (
                        <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1681887388/intel/icons/alldata_icon_ednqbi.svg" />
                      )}
                      <span>{dataSourceList?.[["ch", "pr"].includes(defaultData?.countryCode?.toLowerCase()) ? countryFlag[defaultData?.countryCode?.toLowerCase()] : defaultData?.countryCode?.toLowerCase()]?.[defaultData?.countryType]?.label || "Universal Search"}</span>
                    </div>
                  ) : (
                    <div className="tw-text-nowrap tw-flex tw-items-center">
                      {searchCardDetails?.dataSource?.includes("multi") || searchCardDetails?.dataSource.includes("world") ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1681887388/intel/icons/alldata_icon_ednqbi.svg" /> : searchCardDetails?.dataSource?.includes("middleeast") ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1759845304/intel/misc/Middle_East_vtbphh.svg" className="tw-h-3.5 tw-w-3.5 mr-2" /> : CountryCodeOneToOneMap[searchCardDetails?.dataSource?.split("_")[0]] ? <ReactCountryFlag className="trademo-search-flag mr-2" svg countryCode={CountryCodeOneToOneMap[searchCardDetails?.dataSource?.split("_")[0]]} /> : searchCardDetails?.dataSource?.split("_")?.[0] ? <ReactCountryFlag className="trademo-search-flag mr-2" countryCode={searchCardDetails?.dataSource?.split("_")?.[0]} svg /> : <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1681887388/intel/icons/alldata_icon_ednqbi.svg" />}
                      <span>{searchCardDetails?.dataSource?.includes("multi") || searchCardDetails?.dataSource.includes("world") ? "Universal Search " : dataSourceList?.[searchCardDetails?.dataSource?.split("_")[0]]?.[searchCardDetails?.dataSource?.split("_")[1]]?.label || "Universal Search"}</span>
                    </div>
                  )}
                  <ChevronDown size={16} />
                </div>
              </div>
              {showDropdown && <DataSource showHeaderDropdown={showDropdown} closeHeaderDropDown={() => setShowDropdown(false)} updateMultiCountryDataSourceHandler={props.updateMultiCountryDataSourceHandler} isMultiEnabled={true} companyProfileDataSourceAccess={dataSourceAccess ?? []} comingFrom={window.location.search.includes("redirectingFrom=") ? true : false} type={props?.type ?? ""} showGetInTouch={showGetInTouch} handleGetInTouchClose={handleGetInTouchClose} />}
              <div className="tw-border-r tw-rotate-180 tw-border-gray-200 tw-h-full tw-ml-4" />
            </div>
          )}
          <div
            className="tw-flex tw-flex-col tw-gap-1.5 tw-min-w-[48%] tw-justify-center tw-mr-auto"
            onClick={() => {
              setShowAutoSuggest(true);
              inputRef?.current?.focus();
              maintainInputFocus();
            }}
            ref={wrapperRef}>
            <span className="tw-text-xs tw-font-medium tw-text-gray-900">Search keyword</span>
            <div className="tw-flex tw-gap-1.5 tw-w-full">
              {Object.keys(searchKeyLabel || {}).length > 0 && searchKeyLabel?.value !== searchPhraseDictionary.entire_bill_of_lading && (
                <div className="tw-py-1 tw-px-2 tw-flex tw-items-center tw-gap-1  tw-rounded-[54px] tw-bg-gray-900 tw-shadow-autoSuggestPill tw-text-white">
                  <div className="tw-w-4 tw-h-4 tw-rounded-lg tw-px-1 tw-text-xs tw-text-white" style={{ backgroundColor: PillColor[searchKeyLabel?.value] }}>
                    {searchKeyLabel?.label?.substring(0, 1)?.toUpperCase()}
                  </div>
                  <div className="tw-text-sm tw-text-nowrap">{searchKeyLabel?.label}</div>
                  <div
                    className="tw-cursor-pointer"
                    onClick={() => {
                      setSearchKeyLabel(defaultSearchKey);
                      setInputValue("");
                      setSelectedData([]);
                      setShowAddDropdown(false);
                      setFilteredSuggestions([]);
                      setIsOpen(true);
                      setMatchType(match_type_options[0]);
                      setShowAutoSuggest(false);
                      setShowSuggestions(true);
                      setClickPostSearchSugg(false);
                      dispatch(
                        searchParametersHandler({
                          searchCategory: "",
                          searchedItem: "",
                          dataSource: `multi_country`,
                          matchType: "contains",
                        })
                      );
                    }}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#fff">
                      <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" />
                    </svg>
                  </div>
                </div>
              )}
              {selectedData?.length && !showAutoSuggest ? (
                <div key={selectedData?.[0].value} className="tw-flex tw-gap-1  tw-items-center tw-rounded-[54px] tw-border tw-border-primary-purple-600 tw-shadow-autoSuggestPill tw-py-1 tw-px-2">
                  <div className="tw-text-xs tw-text-gray-900 tw-text-nowrap tw-max-w-[120px] tw-overflow-hidden tw-whitespace-nowrap tw-text-ellipsis">{selectedData?.[0].label}</div>

                  <div
                    className="tw-cursor-pointer"
                    onClick={() => {
                      const data = selectedData.filter((item) => item.value !== selectedData[0].value);
                      setSelectedData(data);
                      dispatch(
                        searchParametersHandler({
                          searchCategory: searchKeyLabel.value,
                          searchedItem: data.length > 0 ? data.map((item) => item.label).join("||") : data.value ? data.value : "",
                          dataSource: `multi_country`,
                          matchType: match_type_options[0].value,
                        })
                      );
                      setClickPostSearchSugg(false);
                      if (searchKeyLabel.value === searchPhraseDictionary.product_category && data.length === 0) {
                        setFilteredSuggestions([]);
                        fetchSuggestions(data);
                        setIsOpen(false);
                        setShowAutoSuggest(true);
                        setShowSuggestions(true);
                      } else if (data.length === 0) {
                        setIsOpen(true);
                        setFilteredSuggestions([]);
                      }
                    }}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#000">
                      <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" />
                    </svg>
                  </div>
                </div>
              ) : (
                <input
                  type="text"
                  ref={inputRef}
                  value={inputValue}
                  disabled={(currentPlanAccess?.is_free_trial && currentPlanAccess?.search_current_count >= currentPlanAccess?.search_max_count) || searchDisable}
                  className="tw-w-full tw-text-sm tw-font-medium tw-text-gray-900 tw-placeholder-gray-500 disabled:tw-bg-white disabled:tw-cursor-not-allowed"
                  placeholder={dropdownOptions?.find((item) => item?.value === searchKeyLabel.value)?.placeHolder || dropdownOptions?.[0]?.placeHolder || defaultSearchKey.placeHolder}
                  onFocus={() => {
                    if (searchDisable) return;
                    if (inputValue.length === 0 && suggestions.length === 0) getRecentAutoSuggestSuggestions(searchCardDetails?.dataSource?.split("_")?.[0] || "multi", searchCardDetails?.dataSource?.split?.("_")?.[1] || "country");
                    setIsOpen(true);
                    setShowDropdown(false);
                    if (filteredSuggestions.length > 0 || Object.keys(filteredSuggestions).length > 0) {
                      setShowAutoSuggest(true);
                      setIsOpen(false);
                    }
                    if (searchKeyLabel.value === searchPhraseDictionary.product_category) setIsOpen(false);
                  }}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyInput}
                />
              )}
              {selectedData.length > 1 && !showAutoSuggest && searchKeyLabel?.value !== searchPhraseDictionary.entire_bill_of_lading && (
                <div className="tw-flex tw-gap-1 tw-items-center tw-rounded-[54px] tw-border tw-border-primary-purple-600 tw-shadow-autoSuggestPill tw-py-1 tw-px-2">
                  <div
                    className="tw-text-xs tw-text-gray-900 tw-text-nowrap tw-cursor-pointer"
                    onClick={() => {
                      setShowAutoSuggest(true);
                      inputRef?.current?.focus();
                      setFilteredSuggestions([]);
                      if (searchKeyLabel.value === searchPhraseDictionary.product_category) fetchSuggestions();
                      maintainInputFocus();
                    }}>
                    +{selectedData.length - 1} more
                  </div>
                </div>
              )}
              {selectedData.length > 0 && !showAutoSuggest && selectedData.length <= 20 && searchKeyLabel?.value !== searchPhraseDictionary.entire_bill_of_lading && (
                <div
                  className="tw-flex tw-gap-1 tw-items-center tw-rounded-[54px] tw-border tw-border-gray-200 tw-cursor-pointer tw-shadow-autoSuggestPill tw-py-1 tw-px-2"
                  onClick={() => {
                    setShowAutoSuggest(true);
                    inputRef?.current?.focus();
                    setFilteredSuggestions([]);
                    if (searchKeyLabel.value === searchPhraseDictionary.product_category) fetchSuggestions();
                    maintainInputFocus();
                    setInputValue("");
                  }}>
                  <div className="tw-text-xs tw-text-gray-900 tw-text-nowrap">+ Add</div>
                </div>
              )}
            </div>
            {isOpen && filteredSuggestions.length === 0 && selectedData.length === 0 && inputValue.length === 0 && (
              <CategoryContainer
                suggestions={suggestions}
                defaultData={defaultData}
                dropdownOptions={dropdownOptions}
                searchKeyLabel={searchKeyLabel}
                setSearchKeyLabel={(value) => setSearchKeyLabelHandler(value)}
                setSelectedData={setSelectedData}
                searchButtonClicked={(e, item, chemical) => (props.type ? "" : searchBottonClicked(e, true, item, chemical))}
                setIsMatchTypeExact={setIsMatchTypeExact}
                removeSearchTab={(event, item) => {
                  event.preventDefault();
                  event.stopPropagation();
                  removeSearchTab(item);
                  getRecentAutoSuggestSuggestions(searchCardDetails?.dataSource?.split("_")[0], searchCardDetails?.dataSource?.split("_")[1]);
                }}
              />
            )}
            {(Object.keys(searchKeyLabel).length > 0 && searchKeyLabel?.value !== searchPhraseDictionary.entire_bill_of_lading && showAutoSuggest) || showAddDropdown ? (
              <AutoSuggestDropdown
                loading={isLoaderActive}
                filteredSuggestions={filteredSuggestions}
                showSuggestions={showSuggestions}
                inputRef={inputRef}
                setShowSuggestions={setShowSuggestions}
                setSelectedData={(value) => {
                  setSelectedData(value);
                  setShowAutoSuggest(false);
                }}
                setInputValue={setInputValue}
                inputValue={inputValue}
                setShowAddDropdown={setShowAddDropdown}
                selectedData={selectedData}
                selectedCategory={searchKeyLabel.value}
                setIsSelectedFromAutoSuggest={setIsSelectedFromAutoSuggest}
                setRedirectionId={setRedirectionId}
                redirectionId={redirectionId}
                showLoadMore={showLoadMore}
                setShowLoadMore={setShowLoadMore}
                visibleSuggestions={visibleSuggestions}
                setVisibleSuggestions={setVisibleSuggestions}
                handleSuggestionClick={handleSuggestionClick}
                handleRedirection={handleRedirection}
                searchKeyLabel={searchKeyLabel}
                handleClearAll={handleClearAll}
                setIsMatchTypeExact={setIsMatchTypeExact}
              />
            ) : showAutoSuggest ? (
              <AllCategoryAutoSuggest
                loading={isLoaderActive}
                filteredSuggestions={filteredSuggestions}
                showSuggestions={showSuggestions}
                inputRef={inputRef}
                setShowSuggestions={setShowSuggestions}
                setSelectedData={(value) => {
                  setSelectedData(value);
                  setIsSelectedFromAutoSuggest(true);
                  setShowAutoSuggest(false);
                }}
                setInputValue={setInputValue}
                inputValue={inputValue}
                selectedData={selectedData}
                selectedCategory={searchKeyLabel}
                setSelectedCategory={setSearchKeyLabel}
                setIsSelectedFromAutoSuggest={setIsSelectedFromAutoSuggest}
                setRedirectionId={setRedirectionId}
                redirectionId={redirectionId}
                dropdownOptions={dropdownOptions}
                isRedirect={props?.type ? true : false}
                currentUserPlan={currentPlanAccess?.subscribed_plan}
                analyticsCountryID={props?.analyticsCountryID || searchCardDetails?.dataSource?.split("_")?.join("-")?.toUpperCase()}
              />
            ) : (
              <></>
            )}
          </div>
          {selectedData.length > 0 && (
            <div className="tw-mt-6 tw-cursor-pointer" onClick={handleClearAll}>
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#101828">
                <path d="m291-240-51-51 189-189-189-189 51-51 189 189 189-189 51 51-189 189 189 189-51 51-189-189-189 189Z" />
              </svg>
            </div>
          )}
          <div className="tw-flex tw-items-center">
            <div className="tw-border-r tw-rotate-180 tw-border-gray-200 tw-h-full tw-mr-4" />
            <div className="tw-flex tw-flex-col tw-gap-1.5">
              <span className="tw-text-xs tw-font-medium tw-text-gray-900">Match Type</span>
              <Select
                onFocus={() => {
                  setIsOpen(false);
                  setShowAddDropdown(false);
                  setShowAutoSuggest(false);
                  setShowDropdown(false);
                }}
                options={match_type_options}
                isSearchable={false}
                styles={searchTypeCustomStyles}
                value={matchType}
                onChange={(option) => handleOptionChange(option)}
              />
            </div>
            <div className="tw-flex tw-items-center tw-ml-2">
              <button
                className="tw-bg-primary-purple-500 tw-rounded-[50%] tw-w-[42px] tw-h-[42px] tw-p-[9.3px] tw-flex tw-items-center tw-justify-center disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
                disabled={currentPlanAccess?.is_free_trial && currentPlanAccess?.search_current_count >= currentPlanAccess?.search_max_count}
                type="button"
                onClick={(e) => {
                  if (!searchDisable) handleEnter(e);
                }}>
                <Search size={16} stroke="white" />
              </button>
            </div>
          </div>
        </div>
        {props?.showReset ? (
          <div data-for="reset" data-tip="Clear all searches and filters">
            <Button
              variant={"secondaryWithIcon"}
              size={"medium"}
              className="tw-rounded-[20px]"
              onClick={() => {
                setMatchType(match_type_options[0]);
                setSearchKeyLabel(defaultSearchKey);
                setInputValue("");
                setSelectedData([]);
                setShowAddDropdown(false);
                setFilteredSuggestions([]);
                setShowAutoSuggest(false);
                props.settingSearchButtonClicked(false);
                props?.resetAll();
              }}>
              <span className="material-symbols-outlined">find_replace</span> <span className="tw-text-sm tw-font-medium"> Reset</span>
            </Button>
            <ReactTooltip className="trademo-tooltip" textColor="#FFFFFF" place="bottom" id="reset" />
          </div>
        ) : (
          <></>
        )}
      </div>
      {currentPlanAccess && currentPlanAccess?.is_free_trial && !isNaN(currentPlanAccess?.search_current_count) && currentPlanAccess?.search_current_count < currentPlanAccess?.search_max_count ? (
        <p className="tw-text-sm text-left tw-pt-3 tw-px-6 tw-flex tw-items-center tw-gap-1">
          <span>
            <img src={InfoIcon} alt="..." className="img-fluid" width={24} height={24} />
          </span>
          Remaining searches:{" "}
          <strong>
            <span>{currentPlanAccess && currentPlanAccess?.search_max_count !== 0 ? <span>{currentPlanAccess.search_max_count - currentPlanAccess.search_current_count}</span> : " are less"}</span> for the day
          </strong>
        </p>
      ) : currentPlanAccess && !currentPlanAccess?.is_free_trial && STARTERPLAN && !isNaN(currentPlanAccess?.search_current_count) ? (
        <p className="tw-text-sm text-left tw-pt-3 tw-px-6 tw-flex tw-items-center tw-gap-1">
          <span>
            <img src={InfoIcon} alt="..." className="img-fluid" width={24} height={24} />
          </span>
          Remaining searches:{" "}
          <strong className="tw-border-none tw-px-2 tw-py-0.5 tw-rounded-[30px] tw-bg-semantic-orange-200 tw-text-xs tw-font-medium tw-text-semantic-orange-600">
            <span>{currentPlanAccess && currentPlanAccess?.search_starter_max_count !== 0 ? <span>{currentPlanAccess.search_starter_max_count - currentPlanAccess.search_starter_current_count}</span> : " are 0"}</span> for the day
          </strong>
        </p>
      ) : (
        <></>
      )}
      {currentPlanAccess?.is_free_trial && currentPlanAccess?.search_current_count >= currentPlanAccess?.search_max_count ? (
        <p className="tw-text-sm text-left tw-pt-3 tw-px-6 tw-flex tw-items-center">
          <span>
            <img src={InfoIcon} alt="..." className="img-fluid" />
          </span>
          You have used all {currentPlanAccess?.search_max_count && currentPlanAccess?.search_max_count !== null ? currentPlanAccess?.search_max_count : "all"} searches today{" "}
          <span className="tw-flex tw-gap-1 tw-items-center tw-text-xs tw-text-secondary-green tw-font-semibold">
            <div onClick={() => upgradeNow()} className="tw-flex tw-items-center tw-mr-1 tw-cursor-pointer hover:tw-underline">
              <span>
                <img src={UpgradeGreenIcon} alt="..." className="img-fluid" />
              </span>
              Upgrade for more
            </div>
          </span>
          or wait for tomorrow
        </p>
      ) : (
        <></>
      )}
      {showFavModal && <AddFavModal profileType={profileTypeHandler(window.location.search)} show={showFavModal} handleClose={() => setShowFavModal(false)} prospectData={prospectData} type={countryType && countryType.toLowerCase() === "import" ? "import" : "export"} tradeDirection={countryType && countryType.toLowerCase() === "import" ? "import" : "export"} country={summaryData?.country ?? ""} dataSource={summaryData?.country?.toLowerCase() ?? ""} setIsFavourite={setIsFavourite} />}
      {showEmailAlert && (
        <CompanyProfileEmailAlertModal
          show={showEmailAlert}
          handleClose={() => {
            setShowEmailAlert(false);
            if (props.callingPendoEvent) {
              props.callingPendoEvent(trackingEventDictionary.companyProfileSetEmailAlertCancel);
            }
          }}
          addToFavourite={() => addToFavouriteHandler()}
          company_name={summaryData?.name || summaryData?.trade_lane_name}
        />
      )}
    </div>
  );
};
export default PrimarySearchCard;
